import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ConsultaAdminComponente from "../../components/utils/ConsultaAdminComponente";

export default function ConsultasAdmin() {
  return (
     <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Consultas Administrador" />

        {/* RoleAccessLayer */}
        <ConsultaAdminComponente/>

      </MasterLayout>

    </>
  )
}
